// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'PRN payments'"></sub-header>

  <div class="tab-menu">
    <ul class="nav-tabs">
      <li class="active">
        <a data-target="#tab_lookup" data-toggle="tab">
          <span>Individual SSS Lookup</span>
        </a>
      </li>
      <li>
        <a data-target="#tab_payment" data-toggle="tab">
          <span>PRN online payment</span>
        </a>
      </li>
    </ul>
  </div>

  <div class="tab-content" style="overflow: unset">
    <div class="tab-pane active" id="tab_lookup">
      <sss-lookup-prn></sss-lookup-prn>
    </div>

    <div class="tab-pane" id="tab_payment">
      <sss-online-employer-payment
        ng-if="\$ctrl.payorKind === 'EMPLOYER'"
        payor-kind="\$ctrl.payorKind"
        on-save-action="\$ctrl.onSaved"
        cancel-action="\$ctrl.cancelChanges"
      >
      </sss-online-employer-payment>
      <sss-online-individual-payment
        ng-if="\$ctrl.payorKind === 'INDIVIDUAL'"
        payor-kind="\$ctrl.payorKind"
        on-save-action="\$ctrl.onSaved"
        cancel-action="\$ctrl.onCancelChanges"
      >
      </sss-online-individual-payment>
    </div>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/sss-online-payment/sss-online-payment.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;